export const validCoupons = {
  webhostingNoLimit: {
    code: "WN2616TWAJ",
    validUntil: "31.12.2026",
  },
  webhostingLowCost: {
    code: "WN251YEAKI",
    validUntil: "10.12.2025",
  },
  vpsOn: {
    code: "VN261OVUUB",
    validUntil: "31.12.2026",
  },
  vpsSsd: {
    code: "VD261L7JYS",
    validUntil: "31.12.2026",
  },
  wordpressHosting: {
    code: "WPXLXGI30H",
    validUntil: "31.12.2026",
  },
  website: {
    code: "WS251YW5UR",
    validUntil: "10.12.2025",
  },
  disk: {
    code: "WD261YSHIV",
    validUntil: "31.12.2026",
  },
  mailhosting: {
    code: "MH2614WLTJ",
    validUntil: "31.12.2026",
  },
  renewal: {
    code: "N16PR",
    validUntil: "20.9.2026",
  },
  domains: {
    code: "DM261BOE47",
    validUntil: "31.12.2026",
  },
};

// Commented out services for reference:
// "cd": {
//   code: "CD251AST7P",
//   validUntil: "31.12.2025",
// },
